module.exports = __webpack_public_path__ + "static/media/Floor2_After.bfffdd49.jpg";